<template>
  <modal
    name="state-change-overlay"
    classes="overlay-modal"
    @before-open="beforeOpen"
    transition="scale"
    height="auto"
    width="90%"
    :clickToClose="false"
  >
    <div class="text-center" style="color:white; text-transform:uppercase">
      <div class="termina-bold">
        <h2 style="padding-bottom:0px; margin-bottom:5px">
          {{ line1 }}
        </h2>
        <h2 style="color: #e3452e; padding: 0px; margin: 0px">
          {{ line2 }}
        </h2>
      </div>
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </modal>
</template>
<script>
import config from '../config'

export default {
  data() {
    return { line1: '', line2: '' }
  },
  methods: {
    beforeOpen(event) {
      this.line1 = event.params.line1
      this.line2 = event.params.line2

      setTimeout(() => {
        this.closeModal()
      }, config.stateChangeOverlayModalDuration)
    },
    closeModal() {
      this.$modal.hide('state-change-overlay')
    }
  }
}
</script>
<style scoped>
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: rgb(195, 25, 25);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
